export default {
    "数据后台": {
        zh: "数据后台",
        en: "Data BI"
    },
    "数据中心": {
        zh: "数据中心",
        en: "Data Center"
    },
    "应用中心": {
        zh: "应用中心",
        en: "Game Center"
    },
    "广告户管理": {
        zh: "广告户管理",
        en: "Ads Account"
    },
    "APP户管理": {
        zh: "APP户管理",
        en: "Entity"
    },
    "账号管理": {
        zh: "账号管理",
        en: "BI Account"
    },
    "姓名": {
        zh: "姓名",
        en: "Name"
    },
    "账号": {
        zh: "账号",
        en: "Account"
    },
    "密码": {
        zh: "密码",
        en: "Password"
    },
    "角色": {
        zh: "角色",
        en: "Role"
    },
    "所属账户": {
        zh: "所属账户",
        en: "Access to"
    },
    "操作": {
        zh: "操作",
        en: "Opetate"
    },
    "编辑": {
        zh: "编辑",
        en: "Edit"
    },
    "选户": {
        zh: "选户",
        en: "Select Ads Accounts"
    },
    "删除": {
        zh: "删除",
        en: "Delete"
    },
    "新增账号": {
        zh: "新增账号",
        en: "Add"
    },
    "备注": {
        zh: "备注",
        en: "Note"
    },
    "Token过期时间": {
        zh: "Token过期时间",
        en: "Token Expires at"
    },
    "授权链接": {
        zh: "授权链接",
        en: "Auth Link"
    },
    "新建": {
        zh: "新建",
        en: "Add"
    },
    "添加户": {
        zh: "添加户",
        en: "Add Ads Account"
    },
    "请输入户ID": {
        zh: "请输入户ID",
        en: "Please enter Ads Account ID"
    },
    "包名": {
        zh: "包名",
        en: "Bundle ID"
    },
    "设置包名": {
        zh: "设置包名",
        en: "Edit Bundle ID"
    },
    "设置友盟KEY": {
        zh: "设置友盟KEY",
        en: "Edit Umeng KEY"
    },
    "投放数据": {
        zh: "投放数据",
        en: "Ads Data"
    },
    "收益数据": {
        zh: "收益数据",
        en: "Monetization"
    },
    "请选择应用": {
        zh: "请选择应用",
        en: "Select Game"
    },
    "所有应用": {
        zh: "所有应用",
        en: "All Games"
    },
    "下载表格": {
        zh: "下载表格",
        en: "Download"
    },
    "重置": {
        zh: "重置",
        en: "Reset"
    },
    "总计": {
        zh: "总计",
        en: "Total/Ave"
    },
    "消耗": {
        zh: "消耗",
        en: "Cost"
    },
    "激活": {
        zh: "激活",
        en: "Activation"
    },
    "预计收益": {
        zh: "预计收益",
        en: "Revenue"
    },
    "至今ROI": {
        zh: "至今ROI",
        en: "ROI"
    },
    "首日ROI": {
        zh: "首日ROI",
        en: "d1 ROAS"
    },
    "时长": {
        zh: "时长",
        en: "Time"
    },
    "次留": {
        zh: "次留",
        en: "RR"
    },
    "户": {
        zh: "户",
        en: "Entity"
    },
    "自定义列": {
        zh: "自定义列",
        en: "Customize"
    },
    "开始日期": {
        zh: "开始日期",
        en: "Start"
    },
    "结束日期": {
        zh: "结束日期",
        en: "End"
    },
    "请选择国家": {
        zh: "请选择国家",
        en: "Select Country"
    },
    "请选择投放主体": {
        zh: "请选择投放主体",
        en: "Select Ads Account"
    },
    "请选择变现主体": {
        zh: "请选择变现主体",
        en: "Select Entity"
    },
    "前7日": {
        zh: "前7日",
        en: "Last 7 days"
    },
    "本月": {
        zh: "本月",
        en: "This Month"
    },
    "今日": {
        zh: "今日",
        en: "Today"
    },
    "昨日": {
        zh: "昨日",
        en: "Yesterday"
    },
    "下载报表": {
        zh: "下载报表",
        en: "Download"
    },
    "应用": {
        zh: "应用",
        en: "Games"
    },
    "至今ROAS": {
        zh: "至今ROAS",
        en: "ROAS"
    },
    "首日ROAS": {
        zh: "首日ROAS",
        en: "D1 ROAS"
    },
    "总条数": {
        zh: "总条数",
        en: "Total"
    },
    "总计": {
        zh: "总计",
        en: "Total"
    },
    "条/页": {
        zh: "条/页",
        en: "/page"
    },
    "全部": {
        zh: "全部",
        en: "All"
    },
    "输入包名或应用名搜索": {
        zh: "输入包名或应用名搜索",
        en: "Enter bundle name"
    },
    "查看": {
        zh: "查看",
        en: "Detail"
    },
    "友盟KEY": {
        zh: "友盟KEY",
        en: "Umeng KEY"
    },
    "请输入包名": {
        zh: "请输入包名",
        en: "Enter bundle name"
    },
    "请输入友盟KEY": {
        zh: "请输入友盟KEY",
        en: "Enter Umeng KEY"
    },
    "户ID": {
        zh: "户ID",
        en: "Ads Account ID"
    },
    "客户端ID": {
        zh: "客户端ID",
        en: "Client ID"
    },
    "客户端密钥": {
        zh: "客户端密钥",
        en: "Client Secret"
    },
    "请输入备注": {
        zh: "请输入备注",
        en: "Note"
    },
    "添加AppGallery": {
        zh: "添加AppGallery",
        en: "Add AppGallery"
    },
    "管理员": {
        zh: "管理员",
        en: "Admin"
    },
    "优化师": {
        zh: "优化师",
        en: "Optimizer"
    },
    "产品": {
        zh: "产品",
        en: "Games"
    },
    "请选择": {
        zh: "请选择",
        en: "Select"
    },
    "选择所属账户": {
        zh: "选择所属账户",
        en: "Select "
    },
    "请输入账号": {
        zh: "请输入账号",
        en: "Account"
    },
    "请输入密码": {
        zh: "请输入密码",
        en: "Password"
    },
    "登陆": {
        zh: "登陆",
        en: "Log in"
    },
    "日期": {
        zh: "日期",
        en: "Date"
    },
    "收益": {
        zh: "收益",
        en: "Revenue"
    },
    "至": {
        zh: "至",
        en: "-"
    },
    "确定": {
        zh: "确定",
        en: "Confirm"
    },
    "取消": {
        zh: "取消",
        en: "Cancel"
    },
    "总览": {
        zh: "总览",
        en: "Overview"
    },
    "按月展示": {
        zh: "按月展示",
        en: "Group By Month"
    },
    "按日展示": {
        zh: "按日展示",
        en: "Group By Date"
    },
    "注销账号": {
        zh: "注销账号",
        en: "Logout"
    },
    "修改密码": {
        zh: "修改密码",
        en: "Alter Password"
    },
    "请输入新密码": {
        zh: "请输入新密码",
        en: "Please enter a new password"
    },
    "请再次输入新密码": {
        zh: "请再次输入新密码",
        en: "Please enter new password again"
    },
    "投放管理": {
        zh: "投放管理",
        en: "Ads Manager"
    },
    "计划托管": {
        zh: "计划托管",
        en: "Ads Auto"
    },
    "投放管理": {
        zh: "投放管理",
        en: "Ads Manager"
    },
    "计划托管": {
        zh: "计划托管",
        en: "Ads Auto"
    },
    "创建计划托管": {
        zh: "创建计划托管",
        en: "Create Task"
    },
    "使用者": {
        zh: "使用者",
        en: "User"
    },
    "最低消耗": {
        zh: "最低消耗",
        en: "Cost >"
    },
    "最高消耗": {
        zh: "最高消耗",
        en: "Cost <"
    },
    "Roas小于": {
        zh: "Roas小于",
        en: "ROAS <"
    },
    "Roas阈值": {
        zh: "Roas阈值",
        en: "ROAS Threshold"
    },
    "检查时间": {
        zh: "检查时间",
        en: "Time"
    },
    "操作": {
        zh: "操作",
        en: "Operation"
    },
    "系统操作日志": {
        zh: "系统操作日志",
        en: "Log"
    },
    "操作日志": {
        zh: "操作日志",
        en: "Log"
    },
    "操作时间": {
        zh: "操作时间",
        en: "Operation Time"
    },
    "计划ID": {
        zh: "计划ID",
        en: "Campaign ID"
    },
    "当时消耗": {
        zh: "当时消耗",
        en: "Cost"
    },
    "当时IAA": {
        zh: "当时IAA",
        en: "IAA"
    },
    "关闭计划": {
        zh: "关闭计划",
        en: "Pause"
    },
    "生效账户": {
        zh: "生效账户",
        en: "Select Accounts"
    },
    "编辑托管计划": {
        zh: "编辑托管计划",
        en: "Edit Task"
    },
    "确定删除该托管计划吗": {
        zh: "确定删除该托管计划吗",
        en: "Are you sure to delete?"
    },
    "修改成功": {
        zh: "修改成功",
        en: "Successfully modified"
    },
    "修改失败": {
        zh: "修改失败",
        en: "Failed to modify"
    },
    "操作成功": {
        zh: "操作成功",
        en: "Operation Completed"
    },
    "操作失败": {
        zh: "操作失败",
        en: "Operation Imcompleted"
    },
    "暂无操作日志": {
        zh: "暂无操作日志",
        en: "No Log Yet"
    },
    "选择创建人": {
        zh: "选择创建人",
        en: "Select User"
    },
    "创建任务": {
        zh: "创建任务",
        en: "Create Ads"
    },
    "资源库": {
        zh: "资源库",
        en: "Assets"
    },
    "视频": {
        zh: "视频",
        en: "Video"
    },
    "图片": {
        zh: "图标",
        en: "Image"
    },
    "设置备注": {
        zh: "设置备注",
        en: "Set Remark"
    },
    "开启计划": {
        zh: "开启计划",
        en: "Resume"
    },
    "计划": {
        zh: "计划",
        en: "Campaign"
    },
    "刷新": {
        zh: "刷新",
        en: "Sync"
    },
    "刷新中": {
        zh: "刷新中",
        en: "synchronizing"
    },
    "创建计划": {
        zh: "创建计划",
        en: "Create"
    },
    "计划名称": {
        zh: "计划名称",
        en: "Campaign Name"
    },
    "计划ID": {
        zh: "计划ID",
        en: "Campaign ID"
    },
    "户": {
        zh: "户",
        en: "Account"
    },
    "创建时间": {
        zh: "创建时间",
        en: "Time"
    },
    "操作": {
        zh: "操作",
        en: "Operation"
    },
    "复制": {
        zh: "复制",
        en: "Copy"
    },
    "投放账号": {
        zh: "投放账号",
        en: "Account"
    },
    "任务清单": {
        zh: "任务清单",
        en: "Task List"
    },
    "新任务": {
        zh: "新任务",
        en: "New Task"
    },
    "删除": {
        zh: "删除",
        en: "Delete"
    },
    "投放应用": {
        zh: "投放应用",
        en: "Application"
    },
    "投放日期": {
        zh: "投放日期",
        en: "Date"
    },
    "请选择": {
        zh: "请选择",
        en: "Select"
    },
    "不限日期": {
        zh: "不限日期",
        en: "No End Date"
    },
    "选择日期范围": {
        zh: "选择日期范围",
        en: "Date Range"
    },
    "投放时间": {
        zh: "投放时间",
        en: "Duration"
    },
    "全天": {
        zh: "全天",
        en: "All Day"
    },
    "特定时间段": {
        zh: "特定时间段",
        en: "Specific Hours"
    },
    "营销目标": {
        zh: "营销目标",
        en: "Goal"
    },
    "智能应用推广": {
        zh: "智能应用推广",
        en: "UAC"
    },
    "销售转化": {
        zh: "销售转化",
        en: "Sales"
    },
    "搜索广告": {
        zh: "搜索广告",
        en: "Search"
    },
    "计划预算": {
        zh: "计划预算",
        en: "Daily Budget"
    },
    "请输入": {
        zh: "请输入",
        en: "Enter"
    },
    "定向包": {
        zh: "定向包",
        en: "Targeting Template"
    },
    "新建定向包": {
        zh: "新建定向包",
        en: "New Targeting Template"
    },
    "同步定向包": {
        zh: "同步定向包",
        en: "Sync Targeting Template"
    },
    "版位": {
        zh: "版位",
        en: "Slot"
    },
    "无数据": {
        zh: "无数据",
        en: "No Data"
    },
    "出价方式": {
        zh: "出价方式",
        en: "Bid Type"
    },
    "出价": {
        zh: "出价",
        en: "Bid"
    },
    "底价": {
        zh: "底价",
        en: "Minimum"
    },
    "任务名称": {
        zh: "任务名称",
        en: "Task Name"
    },
    "开始时间": {
        zh: "开始时间",
        en: "Start"
    },
    "结束时间": {
        zh: "结束时间",
        en: "End"
    },
    "选择投放时间": {
        zh: "选择投放时间",
        en: "Select"
    },
    "请输入内容": {
        zh: "请输入内容",
        en: "请输入内容"
    },
    "定向包名称": {
        zh: "定向包名称",
        en: "定向包名称"
    },
    "定向包描述": {
        zh: "定向包描述",
        en: "定向包描述"
    },
    "国家": {
        zh: "国家",
        en: "Country"
    },
    "请输入关键词": {
        zh: "请输入关键词",
        en: "请输入关键词"
    },
    "新建创意": {
        zh: "新建创意",
        en: "新建创意"
    },
    "创建创意": {
        zh: "创建创意",
        en: "创建创意"
    },
    "选择视频": {
        zh: "选择视频",
        en: "选择视频"
    },
    "视频格式": {
        zh: "视频格式",
        en: "视频格式"
    },
    "视频大小": {
        zh: "视频大小",
        en: "视频大小"
    },
    "视频尺寸": {
        zh: "视频尺寸",
        en: "视频尺寸"
    },
    "视频时长": {
        zh: "视频时长",
        en: "视频时长"
    },
    "长度": {
        zh: "长度",
        en: "长度"
    },
    "文案长度": {
        zh: "文案长度",
        en: "文案长度"
    },
    "选择图片": {
        zh: "选择图片",
        en: "选择图片"
    },
    "图片数量": {
        zh: "图片数量",
        en: "图片数量"
    },
    "图片格式": {
        zh: "图片格式",
        en: "图片格式"
    },
    "图片大小": {
        zh: "图片大小",
        en: "图片大小"
    },
    "图片尺寸": {
        zh: "图片尺寸",
        en: "图片尺寸"
    },
    "选择图标": {
        zh: "选择图标",
        en: "选择图标"
    },
    "图标格式": {
        zh: "图标格式",
        en: "图标格式"
    },
    "图标大小": {
        zh: "图标大小",
        en: "图标大小"
    },
    "图标尺寸": {
        zh: "图标尺寸",
        en: "图标尺寸"
    },
    "创意名称": {
        zh: "创意名称",
        en: "Creative Name"
    },
    "文本": {
        zh: "文本",
        en: "Text"
    },
    "品牌名称": {
        zh: "品牌名称",
        en: "Brand Name"
    },
    "保存应用组": {
        zh: "保存应用组",
        en: "Save App Group"
    },
    "应用组": {
        zh: "应用组",
        en: "App Group"
    },
    "删除应用组": {
        zh: "删除应用组",
        en: "Delete App Group"
    },
    "确定删除该应用组吗": {
        zh: "确定删除该应用组吗",
        en: "Sure to delete this app group?"
    }
}